<template>
  <div class="locale-switcher">
    <div class="label">
      {{ $t('navBar.language') }}
    </div>
    <LocaleSelect
      :model-value="currentLocale"
      :items="locales"
      item-title="fullName"
      item-value="locale"
      @update:model-value="setLocale"
    />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { filter, includes } from 'lodash';
import { useContextStore } from '@/stores/context';

const context = useContextStore();
const currentLocale = ref(context.getCurrentLocale);

const locales = computed(() => {
  return filter(context.getLocaleInfo, localeInfo =>
    includes(context.getAvailableLocales, localeInfo.locale)
  );
});

const setLocale = locale => {
  currentLocale.value = locale;
  context.setLanguageLocale({ locale });
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 1.2rem;
  font-weight: normal;
  min-width: 6.5rem;
}

.locale-switcher {
  display: flex;
  align-items: center;
}
</style>
